import Phaser from 'phaser'
import DodecahedronScene from './scenes/DodecahedronScene'
import HexahedronScene from './scenes/HexahedronScene'

import HelloWorldScene from './scenes/HelloWorldScene'

const config = {
	type: Phaser.AUTO,
	width: window.innerWidth,
	height: window.innerHeight,
	physics: {
		default: 'arcade',
		arcade: {
			gravity: { y: 200 }
		}
	},
	backgroundColor: '#000000',
    scale: {
		mode: Phaser.Scale.RESIZE,
		autoCenter: Phaser.Scale.CENTER_BOTH,
        width: '100%',
        height: '100%'
	},
	audio: {
        disableWebAudio: true
    },
	scene: [HexahedronScene, DodecahedronScene, HelloWorldScene]
}

export default new Phaser.Game(config)
